import * as moment from 'moment-timezone'

export default (date, tz = 'UTC', locale = 'en') => {
  if (date) {
    moment.locale(locale)
    const str = `${moment.utc(date).tz(tz).format('L')}<br>
    ${moment.utc(date).tz(tz).format('LT')}`
    return str
  } else {
    return date
  }
}
